import React, { useState } from "react";
import {
	UncontrolledButtonDropdown,
	DropdownMenu,
	DropdownToggle,
	Nav,
	NavLink,
	Button,
} from "reactstrap";

export default function FooterDropdown({
	icon,
	value,
	setValue,
	options = [],
	direction = "up",
	buttonClassname = "",
}) {
	const [isOpen, setIsOpen] = useState(false);
	const isDropdown = Array.isArray(options) && options.length > 0;

	const handleClick = (newValue) => {
		setIsOpen(false);
		setValue(newValue);
	};

	const handleButtonClick = () => {
		isDropdown ? setIsOpen((prev) => !prev) : setValue(true);
	};

	if (!isDropdown) {
		return (
			<Button
				className={`d-flex align-items-center markeren-btn btn btn-outline-primary btn-sm ${buttonClassname}`}
				size="sm"
				outline
				color="primary"
				onClick={handleButtonClick}
			>
				{icon}
			</Button>
		);
	}

	return (
		<UncontrolledButtonDropdown isOpen={isOpen} direction={direction}>
			<DropdownToggle 
				className={`d-flex align-items-center markeren-btn btn btn-outline-primary btn-sm ${buttonClassname}`}
				size="sm"
				outline
				color="primary"
				onClick={handleButtonClick}
			>
				{icon}
			</DropdownToggle>
			<DropdownMenu className={"rm-pointers dropdown-menu-lg menu-dropdown"}>
				<Nav vertical>
					{options.map((option) => (
						<NavLink
							key={option.value}
							onClick={() => handleClick(option.value)}
							active={option.value === value}
						>
							{option.name}
						</NavLink>
					))}
				</Nav>
			</DropdownMenu>
		</UncontrolledButtonDropdown>
	);
}
